module.exports = __webpack_public_path__ + "static/media/capy_page_area04_img_en@2x.12217ca5.png";